import React from 'react'
import PropTypes from 'prop-types'
import {Box, Link, HStack, Stack, Text} from '@salesforce/retail-react-app/app/components/shared/ui'

const StoreDescription = ({store, showDistance, showName = true, showPhone = true}) => {
    return (
        <Stack
            gap="6px"
            color="black"
            fontSize="14px"
            fontWeight="300"
            lineHeight="22px"
            letterSpacing="0.07px"
        >
            {showName && (
                <HStack gap="10px" alignItems="start" justifyContent="space-between">
                    {store.name && (
                        <Text
                            fontSize="16px"
                            fontWeight="400"
                            lineHeight="25px"
                            letterSpacing="0.08px"
                            textTransform="capitalize"
                        >
                            {store.name.toLowerCase()}
                        </Text>
                    )}

                    {store.distance && showDistance && <Text>{store.distance}</Text>}
                </HStack>
            )}

            {store.calloutMessage && (
                <Box
                    sx={{
                        p: {
                            fontStyle: 'italic'
                        }
                    }}
                    dangerouslySetInnerHTML={{__html: store.calloutMessage}}
                />
            )}
            {showPhone && store.phone && (
                <Box>
                    <Link href={`tel:${store.phone}`}>{store.phone}</Link>
                </Box>
            )}
            {store.address1 && (
                <Text textTransform="capitalize">{store.address1.toLowerCase()}</Text>
            )}

            <Box>
                {store.city && (
                    <Text as="span" textTransform="capitalize">
                        {store.city.toLowerCase()}
                    </Text>
                )}
                {', '}
                {store.stateCode && <Text as="span">{store.stateCode}</Text>}{' '}
                {store.zip && <Text as="span">{store.zip}</Text>}
            </Box>
        </Stack>
    )
}

StoreDescription.propTypes = {
    store: PropTypes.shape({
        ID: PropTypes.string,
        name: PropTypes.string,
        distance: PropTypes.string,
        calloutMessage: PropTypes.string,
        phone: PropTypes.string,
        address1: PropTypes.string,
        city: PropTypes.string,
        stateCode: PropTypes.string,
        zip: PropTypes.string
    }),
    showDistance: PropTypes.bool,
    showName: PropTypes.bool,
    showPhone: PropTypes.bool
}

export default StoreDescription
